import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const cleanBrTags = (htmlString) => {
    // Replace multiple <br> tags with a single space
    return htmlString ? htmlString.replace(/(<br\s*\/?>\s*){2,}/g, ' ') : "";
};

const ReadMore = ({ text, onToggle, sectionId, readMoreUrl, maxChars }) => {
    const navigate = useNavigate();
    const [isExpanded, setIsExpanded] = useState(false);
    const handleReadMoreClick = (event) => {
        event.preventDefault();
        navigate(`${readMoreUrl}`);
        // navigate(`${readMoreUrl}#${sectionId}`);
        setTimeout(() => {
            window.history.replaceState(null, '', readMoreUrl);
        }, 100);
        // setIsExpanded(true)
    };
    
    const cleanedText = cleanBrTags(text);
    const truncatedText = cleanedText.length > maxChars ? cleanedText.slice(0, maxChars) + '...' : cleanedText;
    const chartsCount = 92;
    const shouldTruncate = text.length > chartsCount;
    return (
        <div className='vehicle-desc'>
            <p className={`content-container ${isExpanded ? '' : 'truncated-text'}`}>
                <span 
                    dangerouslySetInnerHTML={{ __html: isExpanded ? cleanedText : truncatedText }} 
                />
                {!isExpanded && shouldTruncate && (
                    <a 
                        // href={`${readMoreUrl}#${sectionId}`} 
                        href={`${readMoreUrl}`} 
                        onClick={handleReadMoreClick} 
                        className='read-more-link text-green'
                    >
                        Read More
                    </a>
                )}
            </p>
        </div>
    );
};

export default ReadMore;
